import { useRef, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { LOCALES, I18N_TO_URL_LANG, LANGUAGE } from "../utils/constants";
import AppConfigContext from "../context/AppConfigContext";

const LanguageSwitcher = () => {
    const { config } = useContext(AppConfigContext);
    const { t, i18n } = useTranslation(config.theme, { keyPrefix: "header" });
    const langRef = useRef();
    const navigate = useNavigate();
    const location = useLocation();

    const onChangeLang = () => {
        const langCode = langRef.current.value;
        i18n.changeLanguage(langCode, () => {
            window.localStorage.setItem('locale', langCode);
            const params = new URLSearchParams(location.search);
            if (langCode === LANGUAGE.English) {
                params.delete('lang');
            } else {
                params.set('lang', I18N_TO_URL_LANG[langCode]);
            }
            navigate({ search: params.toString() }, { replace: true }); // update URL without full reload
        });
    };

    // Keep dropdown in sync with i18n on mount or i18n change
    useEffect(() => {
        const currentLang = i18n.language;
        if (langRef.current) {
            langRef.current.value = currentLang;
        }
    }, [i18n.language]);

    return (
        <Form.Select
            aria-label={config.isMultiLingual ? t("selectLanguage") : "Select Language"}
            className="w-auto"
            size="sm"
            defaultValue={localStorage.getItem('locale') ?? i18n.language}
            onChange={onChangeLang}
            ref={langRef}
        >
            {LOCALES.map(({ code, label }) => (
                <option key={code} value={code}>
                    {label}
                </option>
            ))}
        </Form.Select>
    );
};

export default LanguageSwitcher;
